import React, { useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import {
    Button,
    Form,
    Input,
    Item,
    Modal,
    ModalHeader,
    ModalCloseButton,
    DisplayExtraSmall,
    Text,
} from 'prospect-path-base'
import { CreateButton as DefaultCreateButton } from 'prospect-path-components';

const RestrictedWidthModal = styled(Modal)`
  max-width: 464px;
`;


const CreateTeamModal = ({ onCloseButtonClicked, onCreateTeamButtonClicked, ...props }) => {
    const [newTeamName, setNewTeamName] = useState('');

    const submitForm = (event) => {
        event.preventDefault();
        onCreateTeamButtonClicked(newTeamName);
    }

    return (
        <RestrictedWidthModal {...props}>
            <ModalHeader
                title={<DisplayExtraSmall as="h1">Create new team</DisplayExtraSmall>}
                subtitle={<Text>You can add products and teammates after signing up</Text>}
                close={<ModalCloseButton onClick={onCloseButtonClicked} />}
            />

            <Form onSubmit={submitForm}>
                <Item label="New team"
                      labelProps={{ htmlFor: 'name' }}
                >
                    <Input
                        placeholder="Team name"
                        id="name"
                        value={newTeamName}
                        onChange={event => setNewTeamName(event.target.value)}
                    />
                </Item>

                <Button
                    size="small"
                    color="primary"
                    block
                    onClick={submitForm}
                >
                    Create team
                </Button>
            </Form>
        </RestrictedWidthModal>
    )
}

CreateTeamModal.propTypes = {
    onCloseButtonClicked: PropTypes.func,
}

export default CreateTeamModal
